import { isReactNative } from 'yofobasement/utils/runtime';

let Alert = {};

if (isReactNative()) {
  Alert = require('react-native').Alert;
}

export default Alert;



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Alert.js